var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgINotificationCredit = function SvgINotificationCredit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#00D1E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2085 5.83398H4.79183C3.98771 5.83398 3.3335 6.4882 3.3335 7.29232V8.05621H16.6668V7.29232C16.6668 6.4882 16.0126 5.83398 15.2085 5.83398ZM16.6668 9.16732H3.3335V13.5423C3.3335 14.3464 3.98771 15.0007 4.79183 15.0007H15.2085C16.0126 15.0007 16.6668 14.3464 16.6668 13.5423V9.16732ZM6.25016 12.9173H5.8335C5.60339 12.9173 5.41683 12.7308 5.41683 12.5007V12.084C5.41683 11.8539 5.60339 11.6673 5.8335 11.6673H6.25016C6.48027 11.6673 6.66683 11.8539 6.66683 12.084V12.5007C6.66683 12.7308 6.48027 12.9173 6.25016 12.9173Z",
    fill: "#FEFFF5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgINotificationCredit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-notification-credit.46b997c0e4df41b5449f494c3b6a65ad.svg";